import { render } from "./base-card-list_pagination.vue?vue&type=template&id=98cbb61a&ts=true"
import script from "./base-card-list_pagination.vue?vue&type=script&lang=ts"
export * from "./base-card-list_pagination.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__